import React from 'react';
import {stringsTranslate} from "../../../locales/CustomTranslater";
import {appWords} from "../../../config/Constants";
import {useHandleLinkClick} from '../../../hooks/useHandleLinkClick';
import KnaekSecondaryButtonNoPadding from "../../AppComponents/KnaekSecondaryButtonNoPadding";

export default function NewBannerSectionForCompanies() {
    const handleLinkClick = useHandleLinkClick();

    const initStrings = {
        heading: stringsTranslate(appWords.for_companies),
        heading2: stringsTranslate(appWords.consistent_visibility_among_students),
        subheading1: stringsTranslate(appWords.knaek_promotional_tool_description1),
        subheading2: stringsTranslate(appWords.knaek_promotional_tool_description2),

        playImgL: "/assets/images/ForCompanies/Rectangle 4.webp",
        playImgSm: "/assets/images/ForCompanies/Rectangle 4sm.png",
        btnContent: stringsTranslate(appWords.knaek_for_entrepreneurs_button),
        brandImg1: '/assets/images/ForCompanies/brands/Layer_1.png',
        brandImg2: '/assets/images/ForCompanies/brands/Layer_1 (1).png',
        brandImg3: '/assets/images/ForCompanies/brands/Layer_1 (2).png',
        brandImg4: '/assets/images/ForCompanies/brands/Layer_1 (3).png',
        brandImg5: '/assets/images/ForCompanies/brands/Layer_1 (4).png',
        brandImg6: '/assets/images/ForCompanies/brands/Layer_1 (5).png',
        brandImg7: '/assets/images/ForCompanies/brands/Layer_1 (6).png',
        brandImg8: '/assets/images/ForCompanies/brands/Layer_1 (7).png',
        brandImg9: '/assets/images/ForCompanies/brands/Layer_1 (8).png',
    };

    return (
        <section id="Home" className="section banner-section-for-companies align-items-start justify-content-center">
            <div className="container-fluid">
                <div className="row">
                    {/* App image and logos */}
                    <div className="col-12 text-center position-relative">
                        <img src={initStrings.playImgL}
                             className="radius-15 banner-section-for-companies-img d-none d-md-inline"
                             alt="App banner"/>
                        <img src={initStrings.playImgSm} className=" banner-section-for-companies-img d-block d-md-none"
                             alt="App banner"/>

                        {/* Logos - hidden on small screens */}
                        {/* Right side */}
                        <img src={initStrings.brandImg1} className="brand-logo brand-logo-hm d-none d-lg-inline"
                             alt="H&M"/>
                        <img src={initStrings.brandImg2} className="brand-logo brand-logo-jopp d-none d-lg-inline"
                             alt="Jopp"/>
                        <img src={initStrings.brandImg3}
                             className="brand-logo brand-logo-thuisbezorged d-none d-lg-inline" alt="Thuisbezorgd"/>
                        <img src={initStrings.brandImg9} className="brand-logo brand-logo-kfc d-none d-lg-inline"
                             alt="KFC"/>

                        {/* Left side */}
                        <img src={initStrings.brandImg4} className="brand-logo brand-logo-mac d-none d-lg-inline"
                             alt="McDonald's"/>
                        <img src={initStrings.brandImg5} className="brand-logo brand-logo-adidas d-none d-lg-inline"
                             alt="Adidas"/>
                        <img src={initStrings.brandImg6} className="brand-logo brand-logo-check d-none d-lg-inline"
                             alt="Check"/>
                        <img src={initStrings.brandImg7} className="brand-logo brand-logo-nike d-none d-lg-inline"
                             alt="Nike"/>
                        <img src={initStrings.brandImg8} className="brand-logo brand-logo-kwantum d-none d-lg-inline"
                             alt="Kwantum"/>

                        {/* Button */}
                        <div className="col-12 text-center button-banner-section">
                            <KnaekSecondaryButtonNoPadding
                                className={"button-banner-style"}
                                title={initStrings.btnContent}
                                onClick={() => handleLinkClick("/contact")}
                            />
                        </div>
                    </div>

                    {/* Text content */}
                    <div
                        className="col-lg-10 offset-lg-1 mb-5 pb-5 pb-lg-0 pb-md-0 ml-3 ml-md-5 ml-lg-5 pl-3 mt-5 text-left">
                        <div className="mb-2 d-flex student-discount-content mt-3">
                            <h1 className={"text-knaek-title heading-text-banner-section"}>{initStrings.heading2}</h1>
                        </div>
                        <div className="mb-2 d-flex student-discount-content pl-0">
                            <p className="p-1 text-knaek-title" style={{fontSize: '17px'}}>{initStrings.subheading1} <br/>{initStrings.subheading2}</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
